export default __webpack_public_path__ + "static/media/banner3.3634dd57.jpg";